import { BigNumber } from '@ethersproject/bignumber'

export const BN_10_18 = BigNumber.from(10).pow(18)
export const BN_ZERO = BigNumber.from(0)
